import React, { useState } from "react";
import styled from "styled-components";

const NumberPad: any = ({ number, setNumber }: any) => {
  const [numberArray, setNumberArray] = useState<any[][]>([
    [1, 2, 3],
    [4, 5, 6],
    [7, 8, 9],
    [<p className="delText">전체삭제</p>, 0, "지우기"],
  ]);

  const resetNumberPad = () => {
    setNumber("");
  };
  const backspaceNumberPad = () => {
    setNumber(number.slice(0, -1));
  };

  const onClickPassword = (value: any) => {

    if (value?.props?.className === "delText") {
      resetNumberPad();
    } else if (value === "지우기") {
      backspaceNumberPad();
    } else {
      setNumber(number + value);
    }
  };
  return (
    <Style>
      <div className="numberPadWrap">
        {numberArray.map((itemArray: number[]) => (
          <div>
            {itemArray.map((item: number, index: number) => {
              return (
                <button
                  key={index}
                  className="numberSource"
                  onClick={() => onClickPassword(item)}
                >
                  {item.toLocaleString() === "지우기" ? (
                    <img
                      src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_backspace_green.svg`}
                      alt="backspace"
                    />
                  ) : (
                    <h2>{item}</h2>
                  )}
                </button>
              );
            })}
          </div>
        ))}
      </div>
    </Style>
  );
};

export default NumberPad;

const Style = styled.div`
  .numberSource {
    width: 33%;
    padding: 25px 0;
  }
  .delText {
    font-size: 20px;
    font-weight: 500;
  }
`;
